import React, { useEffect } from "react";
import "./About.scss";
const About = () => {
  return (
    <>
      <div className="About">
        <div className="about-content">
          <h2>About Us</h2>
          <div className="about-text">
            The primary aim of the “EC Travel" project is to create a
            comprehensive and user-centric web application that revolutionizes
            the travel experience for users. The Objectives in this project are
            Development of a User-Centric Interface, Integration of Travel
            Services, Reliable Location Tracking, Efficient Booking System,
            Optimization of Resource Utilization and more.
          </div>
          <div className="about-text">
            In a world that is constantly on the move, the need for a seamless
            and integrated travel experience has become more crucial than ever.
            Recognizing the challenges faced by travelers in coordinating
            various aspects of their journey, we present “EC Travel“, a web
            application dedicated to making travel simpler, more convenient, and
            enjoyable. VoyageVista is not just a travel app; it's a
            comprehensive travel companion that redefines the way we navigate
            and organize our journeys. With a focus on providing a unified
            platform for all travel-related services.
          </div>
          <div className="about-text">
            The motivation behind the development of ECTravel stems from a
            deep-seated desire to transform the way individuals experience and
            navigate the world of travel. Recognizing the numerous challenges
            and complexities inherent in modern travel, including fragmented
            services, navigation difficulties, and the need to juggle multiple
            platforms, EC Travel aims to provide a holistic solution that
            simplifies and enhances the entire travel experience.
          </div>
          <div className="about-text">
            The current state of travel management presents challenges for
            individuals seeking a seamless and efficient experience. Fragmented
            services, disjointed planning processes, and a lack of integration
            contribute to a less-than-ideal journey for modern travelers. The
            need for a single, user-friendly platform that integrates various
            travel services, streamlines planning, and enhances navigation is
            evident. To address these issues, this project aims to develop “EC
            Travel“, a comprehensive web application which provide all
            travel-related services.
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
